import PartySizeSelector from './PartySizeSelector';

export default PartySizeSelector;
